import React, { Dispatch, FC, useCallback } from "react";

import useStyles from "./styles";
import AddCardComponent from "./subcomponents/AddCardComponent/AddCardComponent";
import UnlockCodeCard from "./subcomponents/UnlockCodeCard/UnlockCodeCard";
import {
  IUnlockCode,
  IUnlockCodeErrorDetail,
  TUnlockCodeListReducer,
  TUnlockCodeListState
} from "./useUnlockCodesState";

interface ICouponUnlockCodesProps {
  unlockCodeState: TUnlockCodeListState;
  unlockCodeStateDispatcher: Dispatch<TUnlockCodeListReducer>;
  getUnlockCodeObjErrorFn: (componentKey: number) => IUnlockCodeErrorDetail;
  isDisabled: boolean;
}

const CouponUnlockCodes: FC<ICouponUnlockCodesProps> = ({
  unlockCodeState,
  unlockCodeStateDispatcher,
  getUnlockCodeObjErrorFn,
  isDisabled
}) => {
  const classes = useStyles({});

  const handleAddUnlockCode = useCallback(() => {
    unlockCodeStateDispatcher({ type: "add-unlock-code" });
  }, [unlockCodeStateDispatcher]);

  const handleModifyUnlockCode = useCallback(
    (unlockCodeKey: number) => (modifiedUnlockCodeData: IUnlockCode) => {
      unlockCodeStateDispatcher({
        type: "modify-unlock-code",
        modifiedComponentKey: unlockCodeKey,
        modifiedUnlockCodeObj: modifiedUnlockCodeData
      });
    },
    [unlockCodeStateDispatcher]
  );

  const handleDeleteUnlockCode = useCallback(
    (unlockCodeKey: number) => () => {
      unlockCodeStateDispatcher({
        type: "delete-unlock-code",
        deletedComponentKey: unlockCodeKey
      });
    },
    [unlockCodeStateDispatcher]
  );

  return (
    <div>
      <div className={classes.unlockCardsContainer}>
        {unlockCodeState.listArr.map(unlockCodeObj => (
          <UnlockCodeCard
            key={unlockCodeObj.componentKey}
            unlockCodeData={unlockCodeObj}
            onModifyUnlockCodeData={handleModifyUnlockCode(
              unlockCodeObj.componentKey
            )}
            unlockCodeErrors={getUnlockCodeObjErrorFn(
              unlockCodeObj.componentKey
            )}
            hasDeleteButton={unlockCodeState.listArr.length > 1}
            onDelete={handleDeleteUnlockCode(unlockCodeObj.componentKey)}
            isDisabled={isDisabled}
          />
        ))}
      </div>
      <AddCardComponent onAdd={handleAddUnlockCode} />
    </div>
  );
};

export default CouponUnlockCodes;
